import { Badge } from "antd";

interface IProps {
    total: number | undefined;
    title: string;
}

export default function BadgeCount({ total, title }: IProps) {
    if (!total) {
        return <span>{title}</span>;
    }

    return (
        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "space-between", width: "100%", paddingRight: 6 }}>
            <span>{title}</span>
            <Badge
                count={total}
                size="small"
                style={{
                    backgroundColor: "#ef4444",
                    color: "#fff",
                    border: "none",
                    boxShadow: "0 2px 6px rgba(239, 68, 68, 0.4)",
                    fontSize: 10.5,
                    fontWeight: 700,
                    height: 18,
                    lineHeight: "18px",
                    padding: "0 5px",
                    borderRadius: 9,
                }}
            />
        </span>
    );
}

